var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Mesas")]),_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":_vm.test}},[_vm._v("Test")]),_c('div',[_c('h2',[_vm._v("result")]),_vm._v(" "+_vm._s(_vm.result)+" ")]),_c('div',[_vm._v(" "+_vm._s(_vm.peoplee)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }